<template>
  <span v-if="agency">
    <span>{{ agency.name }}</span>
    <span v-if="withSystemOwner">（{{ agency.systemOwnerName }}）</span>
  </span>
</template>

<script>
export default {
  name: 'AppAgencyName',
  props: {
    agency: {
      type: Object,
      default: null,
    },
    withSystemOwner: Boolean,
  },
}
</script>

<style></style>
